<template>
    <div class="box box-primary">
        <div class="box-header with-border">
            <h3 class="box-title">Filter</h3>
            <div class="box-tools pull-right">
                <button
                    class="btn btn-box-tool"
                    title="Collapse"
                    type="button"
                    @click="toggleCollapse"
                >
                    <i
                        :class="changeIcon(collapse)"
                        class="fa"
                    ></i>
                </button>
            </div>
        </div>
        <!-- /.box-header -->
        <vue-slide-up-down
            :active="collapse"
            :duration="durationCollapse"
        >
            <div class="box-body">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <form
                            action=""
                            method="get"
                            role="form"
                            @submit.prevent="newQueryURL"
                        >
                            <div class="row">
                                <DateRangeComponentVue
                                    v-if="enableFilterList.includes('datesContact')"
                                    id="filter_dates"
                                    ref="datesContactRef"
                                    :disabled="enableFilter.disableWrapper"
                                    :end="endDate"
                                    :start="startDate"
                                    class-input="form-control"
                                    class-main-block="form-group col-xs-12 col-sm-4 col-lg-4"
                                    placeholder="Dates Range"
                                    title="Dates Contacts"
                                    @change="changeDate"
                                />
                                <multi-select-extended-component
                                    v-if="enableFilterList.includes('lists')"
                                    id="contact_lists"
                                    ref="contactListsRef"
                                    class-main-block="form-group col-lg-4 col-md-6 col-xs-12"
                                    class-select="form-control"
                                    :route="contactListsRoute"
                                    title="Contacts Lists"
                                    placeholder="Select or leave empty"
                                    @setItems="setItems"
                                    @remove="newQueryURL"
                                />
                                <div
                                    :class="enableFilter.disableWrapper"
                                    class="form-group col-xs-12 col-sm-4 col-lg-4"
                                    @click="preventEnter"
                                    @keydown="preventEnter"
                                >
                                    <label class="col-xs-12 hidden-xs">&nbsp;</label>
                                    <button
                                        :class="enableFilter.disableBtn"
                                        class="btn btn-sm btn-primary"
                                        type="submit"
                                    >
                                        Apply
                                    </button>
                                    <a
                                        :class="enableFilter.disableBtn"
                                        :href="getPath()"
                                        class="btn btn-sm btn-info"
                                        @click.prevent="clearFilter"
                                    >
                                        Clear
                                    </a>
                                </div>
                            </div>
                        </form>
                        <div
                            v-if="dateContactsFilterErrors"
                            class="form-group has-error"
                        >
                            <span
                                class="help-block"
                                v-text="dateContactsFilterErrors"
                            ></span>
                        </div>
                    </div>
                </div>
            </div>
        </vue-slide-up-down>
        <!-- /.box-body -->
    </div>
    <!-- /.box -->
</template>

<script>
import DateRangeMixin from '../../mixins/date-range-mixin';
import DateRangeComponentVue from '@/components/partials/DateRangeComponentVue';

export default {
    components: {
        DateRangeComponentVue,
    },
    mixins: [DateRangeMixin],
    props: {
        enableFilter: {
            type: Object,
            default: () => ({}),
        },
        dateContactsDefaultRange: {
            type: String,
            default: '',
        },
        dateContactsFilterErrors: {
            type: String,
            default: '',
        },
        enableFilterList: {
            type: Array,
            default: () => [],
        },
        live: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            startDate: this.formatDate(new Date()),
            endDate: this.formatDate(new Date()),
            localeData: {
                format: 'yyyy-mm-dd',
                firstDay: 0,
            },
            collapse: false,
            durationCollapse: 700,
            currentDate: this.$route.query['filter[dates]'],
            selectedLists: [],
        };
    },
    computed: {
        contactListsRoute() {
            return `/lists/json/data?live_list=${this.live ? 1 : 0}`;
        },
    },
    watch: {
        $route: {
            async handler(val) {
                if (this.enableFilterList.includes('lists') && this.$refs.contactListsRef && this.$refs.contactListsRef.itemModel) {
                    const filterIds = val.query['filter[ids]'];
                    await this.$refs.contactListsRef.setModel(filterIds ? [...filterIds].map(Number) : []);
                }
            },
        },
    },
    mounted() {
        if (this.enableFilterList.includes('datesContact')) {
            if (this.currentDate) {
                this.collapse = true;
                this.queryProcess();
            } else if (this.dateContactsDefaultRange) {
                this.collapse = true;
                this.setDateContactsDefaultRange();
            }
        }

        if (this.enableFilterList.includes('lists')) {
            if (this.$route.query['filter[ids]']) {
                this.collapse = true;

                if (Array.isArray(this.$route.query['filter[ids]'])) {
                    this.selectedLists = this.$route.query['filter[ids]'].map((i) => Number(i));
                } else {
                    this.selectedLists = [+this.$route.query['filter[ids]']];
                }
            }
        }
    },
    methods: {
        setDateContactsDefaultRange() {
            let [startDate, endDate] = this.getDefaultRangeDates();
            this.startDate = this.formatDate(startDate);
            this.endDate = this.formatDate(endDate);
        },
        preventEnter(event) {
            if (this.enableFilter.preventEnterFilter) {
                return event.preventDefault();
            }
        },
        queryProcess() {
            let values = this.$route.query['filter[dates]'];
            let dateRegexp = /\d{4}-\d{2}-\d{2}\s-\s\d{4}-\d{2}-\d{2}/;

            if (dateRegexp.test(values)) {
                let dates = values.split(' - ');
                this.startDate = dates[0];
                this.endDate = dates[1];
            }
        },
        formatDate(value) {
            if (value) {
                return window.moment(value.toISOString()).format('YYYY-MM-DD');
            }
        },
        newQueryURL() {
            let query = {
                page: 1,
            };

            if (this.enableFilterList.includes('datesContact')) {
                query['filter[dates]'] =
                    window.moment(this.startDate).format('YYYY-MM-DD') + ' - ' + window.moment(this.endDate).format('YYYY-MM-DD');
            }

            if (this.enableFilterList.includes('lists')) {
                query['filter[ids]'] = this.$refs.contactListsRef.getValue();
            }

            return this.$router.push({
                path: this.getPath(),
                query,
            }).catch(() => {});
        },
        clearFilter() {
            this.setDateContactsDefaultRange();
            this.$refs.contactListsRef.clear();
            this.newQueryURL();
        },
        getPath() {
            return this.$route.path;
        },
        changeIcon(value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        toggleCollapse() {
            this.collapse = !this.collapse;
        },
        changeDate(value) {
            let dates = value.split(' - ');
            this.startDate = dates[0];
            this.endDate = dates[1];
        },
        setItems(data, id) {
            this.$refs.contactListsRef.itemModel = data.filter((item) => this.selectedLists.includes(item.id));

            this.$emit('setMainItems', data, id);
        },
    },
};
</script>
